import { Component, Input, OnInit, SimpleChanges } from '@angular/core'; 
import { VhImage, VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';
import { FunctionService} from 'vhobjects-service/src/services';
import { NzImageService } from 'ng-zorro-antd/image';

@Component({
  selector: 'atw-image-product-config',
  templateUrl: './image-product-config.component.html',
  styleUrls: ['./image-product-config.component.scss']
})
export class AtwImageProductConfig implements OnInit {
  isCollapsed: boolean = false;
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  arr_link_page: any;
  currentViewAll: any = {};
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_config từ database
  effect_hover = []
  isApplyShadow: boolean = false;       // Cho phép thêm | chỉnh sửa bóng
  effect_hover_data: any = {}
  // Mảng chứa nội dung các dropdown cài đặt
  style_fields = [
    {
      title: "thong_so_co_ban",
      index: 1,
      isDrop: false
    },
    {
      title: "bo_loc_hinh_anh",
      index: 2,
      isDrop: false
    },
    {
      title: "do_bao_phu",
      index: 3,
      isDrop: false
    },
    {
      title: "bo_tron",
      index: 4,
      isDrop: false
    },
    {
      title: "do_bong",
      index: 5,
      isDrop: false
    },
    {
      title: "cau_hinh_chi_tiet_hieu_ung",
      index: 6,
      isDrop: false
    },
    {
      title: "bien_doi",
      index: 7,
      isDrop: false
    }, {
      title: "them_lien_ket",
      index: 8,
      isDrop: false
    },
    {
      title: 'do_bao_phu',
      index: 9,
      isDrop: false,
    },
    {
      title: 'dieu_chinh_vien',
      index: 10,
    },
    {
      title: 'nen_bieu_tuong',
      index: 11,
    },
  ];
  resolution = null;

  // Mảng chứa nội dung các kiểu bóng định sẵn
  shadow_styles: any = [
    {
      name: 'Kiểu 1',
      objectChoosing: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
      img: "/assets/root/images/system/imgs/box-shadow-1.jpg"
    },
    {
      name: 'Kiểu 2',
      objectChoosing: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
      img: "/assets/root/images/system/imgs/box-shadow-2.jpg"
    },
    {
      name: 'Kiểu 3',
      objectChoosing: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
      img: "/assets/root/images/system/imgs/box-shadow-3.jpg"
    },
    {
      name: 'Kiểu 4',
      objectChoosing: 'rgba(0, 0, 0, 0.16) 0px 1px 4px, rgb(51, 51, 51) 0px 0px 0px 3px',
      img: "/assets/root/images/system/imgs/box-shadow-4.jpg"
    },
    {
      name: 'Kiểu 5',
      objectChoosing: 'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
      img: "/assets/root/images/system/imgs/box-shadow-5.jpg"
    },
    {
      name: 'Kiểu 6',
      objectChoosing: 'rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px',
      img: "/assets/root/images/system/imgs/box-shadow-6.jpg"
    },
    {
      name: 'Kiểu 7',
      objectChoosing: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      img: "/assets/root/images/system/imgs/box-shadow-7.jpg"
    },
    {
      name: 'Kiểu 8',
      objectChoosing: 'rgb(38, 57, 77) 0px 20px 30px -10px',
      img: "/assets/root/images/system/imgs/box-shadow-8.jpg"
    },
    {
      name: 'Kiểu 9',
      objectChoosing: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px',
      img: "/assets/root/images/system/imgs/box-shadow-9.jpg"
    },
    {
      name: 'Kiểu 10',
      objectChoosing: 'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px',
      img: "/assets/root/images/system/imgs/box-shadow-10.jpg"
    },
    {
      name: 'Kiểu 11',
      objectChoosing: 'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
      img: "/assets/root/images/system/imgs/box-shadow-11.jpg"
    },
    {
      name: 'Kiểu 12',
      objectChoosing: 'rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px',
      img: "/assets/root/images/system/imgs/box-shadow-12.jpg"
    },
    {
      name: 'Kiểu 13',
      objectChoosing: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
      img: "/assets/root/images/system/imgs/box-shadow-13.jpg"
    },
    {
      name: 'Kiểu 14',
      objectChoosing: 'rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px',
      img: "/assets/root/images/system/imgs/box-shadow-14.jpg"
    },
    {
      name: 'Kiểu 15',
      objectChoosing: 'rgba(0, 0, 0, 0.45) 0px 25px 20px -20px',
      img: "/assets/root/images/system/imgs/box-shadow-15.jpg"
    },
  ]
  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    private vhImage: VhImage,
    private nzMessageService: NzMessageService,
    private matdialog: MatDialog,
    public functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
    private nzImageService: NzImageService,
  ) { }
  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/image.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
    })

    if (!this.config.hasOwnProperty('is_top_page')) this.config.is_top_page = false;
    if (!this.config.selected_image_index) this.config.selected_image_index = 0;
    if (!this.config['image-fullscreen']?.hasOwnProperty('toggle_fullscreen')) {
      this.config['image-fullscreen'] ??= {};
      this.config['image-fullscreen'].toggle_fullscreen = false;
    }
  }

  ngOnChanges({ device }: SimpleChanges): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.setCustomize(this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [])
    }
    if (this.class['image']?.['background-image'] && this.class['image']['background-image'].includes('url(')) {
      this.class['image']['background-image'] = 'none';
    }
  }

  /**
   * Hàm xử lí khi người dùng bật/tắt chế độ toàn màn hình cho ảnh
   */
  handleOpenFullscreenPreview() {
    const srcTemp = this.staticdata.img || 'https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg'
    const img_preview = [
      {
        src: srcTemp,
        height: '90%',
        position: 'fixed',
      },
    ]
    this.nzImageService.preview(img_preview, { nzZoom: 0.9, nzRotate: 0 });
  }

  /** Xử lí xoay lật
* @param axis : Lật theo trục 'x' | 'y' | 'z' | '-z'
*/
  handleSetTransform(axis) {
    switch (axis) {
      case 'x':       // ---Lật dọc
        if (this.config['transform'].transform_rotateX < 360) {
          this.config['transform'].transform_rotateX += 180;
          this.class['image__boundary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg) "
            + "rotateY(" + this.config['transform'].transform_rotateY + "deg) "
            + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg) "
            + "skewX(" + this.config['transform'].transform_skewX + "deg) "
            + "skewY(" + this.config['transform'].transform_skewY + "deg) ";

        }
        else {
          this.config['transform'].transform_rotateX -= 360;
          this.class['image__boundary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg) "
            + "rotateY(" + this.config['transform'].transform_rotateY + "deg) "
            + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg) "
            + "skewX(" + this.config['transform'].transform_skewX + "deg) "
            + "skewY(" + this.config['transform'].transform_skewY + "deg) "
        }
        break;
      case 'y':       // ---Lật ngang
        if (this.config['transform'].transform_rotateY < 360) {
          this.config['transform'].transform_rotateY += 180;
          this.class['image__boundary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg) "
            + "rotateY(" + this.config['transform'].transform_rotateY + "deg) "
            + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg) "
            + "skewX(" + this.config['transform'].transform_skewX + "deg) "
            + "skewY(" + this.config['transform'].transform_skewY + "deg) "
        }
        else {
          this.config['transform'].transform_rotateY -= 360;
          this.class['image__boundary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg) "
            + "rotateY(" + this.config['transform'].transform_rotateY + "deg) "
            + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg) "
            + "skewX(" + this.config['transform'].transform_skewX + "deg) "
            + "skewY(" + this.config['transform'].transform_skewY + "deg) "
        }
        break;
      case '-z':        // --- Xoay trái
        if (this.config['transform'].transform_rotateZ > -360) {
          this.config['transform'].transform_rotateZ -= 45;
          this.class['image__boundary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg) "
            + "rotateY(" + this.config['transform'].transform_rotateY + "deg) "
            + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg) "
            + "skewX(" + this.config['transform'].transform_skewX + "deg) "
            + "skewY(" + this.config['transform'].transform_skewY + "deg) "
        }
        break;
      case 'z':         // --- Xoay phải
        if (this.config['transform'].transform_rotateZ < 360)
          this.config['transform'].transform_rotateZ += 45;
        this.class['image__boundary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg) "
          + "rotateY(" + this.config['transform'].transform_rotateY + "deg) "
          + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg) "
          + "skewX(" + this.config['transform'].transform_skewX + "deg) "
          + "skewY(" + this.config['transform'].transform_skewY + "deg) "
        break;
      default:
    }
    this.updateObject();
  }
  //Hàm cập nhật giá trị transform
  SetTransform() {
    this.class['image__boundary'].transform = "rotateX(" + this.config['transform'].transform_rotateX + "deg) "
      + "rotateY(" + this.config['transform'].transform_rotateY + "deg) "
      + "rotateZ(" + this.config['transform'].transform_rotateZ + "deg) "
      + "skewX(" + this.config['transform'].transform_skewX + "deg) "
      + "skewY(" + this.config['transform'].transform_skewY + "deg) ";
    this.updateObject()
  }
  /**
    * Cập nhật staticdata vào database.
    */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {

      });

  }
  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId))
      document.getElementById('upload').click();
    // inputVal;

  }
  //Lưu hình ảnh
  saveImage() {
    this.nzMessageService.success("Lưu ảnh thành công")
    this.updateStaticData();
  }
  customize = []
  /**
    *Hàm update config vào database.
    */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      })
  }
  /**
 * Hàm update object vào database.
 */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      })
  }
  /**
  *Hàm update class vào database.
  */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      })

  }
  /**
  * Hàm này dùng để cho phép mở menu config .
  * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
  * @param: value
  */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false, menu9: false
  };
  openMapSub: { [name: string]: boolean } = { menu1: true, menu2: false };
  openHandler(value: string, isSub = false): void {
    const targetMap = isSub ? this.openMapSub : this.openMap;
    Object.keys(targetMap).forEach(key => {
      if (key !== value) targetMap[key] = false;
    });
  }
  /** Áp dụng đổ bóng
 *   * -> xử lí dữ liệu bóng -> css:  box-shadow: `x y blur color`
*/
  handleSetShadow() {
    if (this.config.check_shadow == false)
      this.class['image__boundary--img']['box-shadow'] = "none"
    else {
      this.class['image__boundary--img'].transform = 0.8;
      this.class['image__boundary--img']['box-shadow'] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_color}`;
    }
    this.updateObject();
  }
  /** Xử lí đổ bóng
* -> xử lí dữ liệu bóng -> css:  object-position: `x y blur color`
*/
  handleSetPositionShadow() {
    this.class['image__boundary--img']['box-shadow'] = `${this.config['box-shadow'].box_shadow_x}px ${this.config['box-shadow'].box_shadow_y}px ${this.config['box-shadow'].box_shadow_blur}px ${this.config['box-shadow'].box_shadow_width}px ${this.config['box-shadow'].box_shadow_color}`;
    this.updateObject();
  }
  /**
  * Hàm này dùng để mở rộng phần cấu hình.
  * @param field_text : trả về phần tử được chọn của mảng style_field
  */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }
  onShadowSelected(value, event) {
    if (isPlatformBrowser(this.platformId)) {
      // x y blur width color
      this.class['image__boundary--img']['box-shadow'] = value.objectChoosing;
      var lastSelectElm = document.querySelector('.box-shadow .selected') as HTMLElement;
      if (lastSelectElm)
        lastSelectElm.classList.remove('selected')
      event.currentTarget.classList.add("selected")
      this.updateObject();
    }
  }
  /**
    * remove link khi click vào nút x
    */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData()
  }
  dataAfterChange: any = {};
  updateCss(name, key) {
    this.dataAfterChange[name] = { ...key };
  }

  /**
   * Cập nhật lưu hàm updateCss vào database.
   */
  saveDataProperties() {
    if (Object.keys(this.dataAfterChange).length)
      this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, this.dataAfterChange)
        .then((bool) => {

        }, error => {
          console.error(error)
        })
  }
  updateDynamic(name, value) {
    this.dataAfterChange[name] = value;
    this.saveDataProperties();
  }

  public urlBackgroundImage = ''; // Giá trị đường dẫn của background-image
  /** Hàm thực hiện xử lí khi chuyển lựa chon background
*
* @param event
*/
  handleSetBackground(event) {
    let frameBlank = this.config['image'];
    if (event === 'color') {
      if (this.class['image']['background-color'] == 'transparent') {
        this.class['image']['background-color'] =
          frameBlank['background_color_restore'];
      }
      this.class['image']['background-image'] = 'none';
    }
    if (event === 'image') {
      if (frameBlank['background-image'] == 'none') {
        this.class['image']['background-image'] =
          frameBlank['background_image_restore'];

        // Xử lí cắt chuỗi background-image
        let backgroundImage = this.class['image']['background-image'];
        const startIndex = backgroundImage.indexOf('(') + 1; // Tìm vị trí bắt đầu của phần tử aaa
        const endIndex = backgroundImage.lastIndexOf(')');
        this.urlBackgroundImage = backgroundImage.substring(
          startIndex,
          endIndex
        ); // Cắt phần tử url từ vị trí bắt đầu đến kết thúc
      }
      this.class['image']['background-color'] = 'transparent';
    }
    setTimeout(() => {
      this.updateClass();
      this.updateConfig();
    }, 0);
  }
  /** Hàm sẽ thực hiện disable các option khi lựa chọn tải ảnh nền cho frame
 *
 * @param valueItem
 * @returns
 */
  checkDisableUploadImage(valueItem: any) {
    if (this.config['image'].is_upload_image === valueItem) return false;
    return true;
  }

  /** Xử lí lưu vị trí ảnh
  * -> xử lí dữ liệu bóng -> css:  object-position: `x y`
  */
  handleSetPositionImage() {
    if (this.config.image.object_x == 0 && this.config.image.object_y == 0)
      this.class['image__boundary--img']['object-position'] = 'initial';
    else {
      this.class['image__boundary--img']['object-position'] = `${this.config.image.object_x}px ${this.config.image.object_y}px`;
    }
    this.updateObject();
  }

  //Hàm xử lý scale
  scale() {
    this.class['image__boundary--img']['transform'] = `scale(${this.class['image__boundary--img']['transfrom_scale']})`;
    this.updateClass();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    var effect = this.objectChoosing[this.device + "_config"]['animation-selected'];
    this.class['image__boundary'].transform = "";
    this.class['image']['box-shadow'] = '';

    if (effect.id == '000010') {
      this.class['image__boundary--img']['height'] = ''
    }
    else if (effect.id == '000007') {
      this.class['image__boundary--img']['filter'] = '';
    } 
    else {
      this.class['image__boundary--img']['height'] = '100%';
      this.class['image__boundary--img']['filter'] = 'brightness(100%)  contrast(100%)  saturate(100%)   hue-rotate(0deg)   blur(0px)   opacity(100%)   grayscale(0%)';
    }

    this.updateObject();

    this.setCustomize(event);

    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.style_fields[5]);
    }
  }

  private setCustomize(value) {
    this.customize = value;

    if (['000014', '000035', '000046', '000060'].includes(this.config['animation-selected']['id'])) {
      this.customize = this.customize.filter(item => item.var !== '--6-img-src');
      this.customize.unshift({ label: "", type: "index-image", var: "--6-img-index" });
    }
    else if (['000010', '000042', '000043', '000044'].includes(this.config['animation-selected']['id'])) {
      this.customize = this.customize.filter(item => item.var !== '--1-transition' && item.var !== '--0h1-transition');
      this.customize.unshift({ label: "toc_do_cua_hieu_ung", type: "custom-speed", var: "--1-speed-transition" });
    }
    else if (['000027', '000028'].includes(this.config['animation-selected']['id'])) {
      this.customize = this.customize.filter(item => item.var !== '--1-animation-duration-shared' && item.var !== '--0h1-animation-duration-shared');
      this.customize.unshift({ label: "toc_do_cua_hieu_ung", type: "custom-speed", var: "--1-speed-animation" });
    }

    if (this.staticdata?.[this.device + '_animation']?.['animation-0']?.['--0b-content-used-name']) {
      this.customize = this.customize.filter(item => item.var !== '--0b-content');
    }
  }

  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['image']['width'] = event.width + 'px';
    if (event.height) this.class['image']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass()
  }
}
